module.exports = __webpack_public_path__ + "img/questions-answered.e558c8b5.svg";